import React from 'react';

import { Box, Container, Grid, Typography } from '@material-ui/core';

import { useScreenIsSmallerThan } from '../hooks/useBreakpoints';
import { makeBlockStyles, useBlockStyles } from '../hooks/useStyles';
import { BlockBuilder, BlockHeading } from '../types/_blocks.types';

const useStyles = makeBlockStyles(() => ({
  root: {
    //
  },
}));

type Props = BlockBuilder<BlockHeading>;

export const HeadingBlock: React.FC<Props> = ({ block }) => {
  const { title, show } = block;
  const classes = useBlockStyles(useStyles, block);
  const showHeading = show && useScreenIsSmallerThan(show.size);

  return (
    <>
      {!showHeading && (
        <Box className={classes.boxBlock}>
          <Container className={classes.root}>
            <Grid container justifyContent="center">
              <Grid item xs={12} md={9}>
                <Typography
                  variant="h2"
                  variantMapping={{ h2: 'h1' }}
                  className={classes.typography}
                >
                  {title}
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </Box>
      )}
    </>
  );
};
